// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3jQaP","footer":"ModalError_footer__2XPig"};